Ext.define('SA.VectorMapLayerProperties', {
    singleton: true,

    apply(map, layerId, properties) {
        var setPaintProperty = (property, value) => value !== undefined && map.setPaintProperty(layerId, property, value);

        if (properties.filter !== undefined) {
            map.setFilter(layerId, properties.filter);
        }

        map.setLayoutProperty(layerId, 'visibility', properties.visible ? 'visible' : 'none');

        setPaintProperty('fill-color', properties.fillColor);
        setPaintProperty('line-color', properties.lineColor);
        setPaintProperty('line-width', properties.lineWidth);
    }
});